import React, { useEffect, useState } from "react";
import {
  bgrouplist,
  statemaster,
  stuappointlist,
  stuclasslist,
  studeptlist,
  studesilist,
  studivisionlist,
  stuquallist,
  stureporttolist,
  stushiftlist,
  stusubjectlist,
  getTeacherMasters,
} from "../../../services/master";
import Select from "react-select";
import {
  teachercreate,
  teacherupdate,
  teacherview,
} from "../../../services/teacher";
import { toast } from "react-toastify";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { phonevalidate } from "../../../services/common";
import { academylist, listvehicle } from "../../../services/admin";
import moment from "moment/moment";

export default function Addteacher() {
  const navigate = useNavigate();
  const [urllink, setUrllink] = useState("");
  const { id } = useParams();
  const [tname, setTName] = useState("");
  const [dob, setDob] = useState("");
  const [bgroup, setBgroup] = useState("");
  const [gender, setGender] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [fname, setFName] = useState("");
  const [mname, setMName] = useState("");
  const [add1, setAdd1] = useState("");
  const [add2, setAdd2] = useState("");
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [pincode, setPincode] = useState("");
  const [dist, setDist] = useState("");
  const [pfile, setPFile] = useState("");
  const [purl, setPUrl] = useState("");

  const [mstatus, setMstatus] = useState("");
  const [qual, setQual] = useState("");
  const [dept, setDept] = useState("");
  const [desig, setDesig] = useState("");
  const [report, setReport] = useState("");
  const [appoint, setAppoint] = useState("");
  const [shift, setShift] = useState("");
  const [insname, setInsName] = useState("");
  const [bname, setBName] = useState("");
  const [accno, setAccno] = useState("");
  const [ifscode, setIfsCode] = useState("");
  const [bbranch, setBBranch] = useState("");
  const [subj, setSubj] = useState("");
  const [sublist, setSubList] = useState([]);


  const [adate, setADate] = useState("");
  const [inccls, setIncCls] = useState("");
  const [stusec, setStuSec] = useState("");
  const [tcode, setTCode] = useState("");

  const [bglist, setBgList] = useState([]);
  const [slist, setSList] = useState([]);
  const [qlist, setQList] = useState([]);
  const [dplist, setDpList] = useState([]);
  const [dslist, setDsList] = useState([]);
  const [rlist, setRList] = useState([]);
  const [atlist, setATList] = useState([]);
  const [stlist, setSTList] = useState([]);
  const [clslist, setClsList] = useState([]);
  const [seclist, setSecList] = useState([]);

  const [alist, setAList] = useState([]);
  const [acaid, setAcaID] = useState("");
  const [stutype, setStuType] = useState(1);


  const [username, setUserName] = useState("");
  const [pswd, setPswd] = useState("");

  function LetterOnly(eve) {
    if (/^[a-zA-Z\s]*$/.test(eve.key)) {
      return true;
    } else {
      eve.preventDefault();
      return false;
    }
  }

  function onPasteLetter(e) {
    const str = e.clipboardData.getData("Text");
    const newStr = str.replace(/[+-.]/g, "");
    if (str !== newStr) {
      e.preventDefault();
    }
  }
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/")[2]; // Extracts 'allteacher' or 'leftteacherlist'
    setUrllink(path);
    listyear("");

    // All master dropdowns come from ONE cached combiner call (no parallel
    // burst). Served from cache after the first load, so this page makes
    // ~zero master requests — avoids the shared-host process limit that caused
    // "SQLSTATE[HY000] [2002] Operation not permitted".
    getTeacherMasters().then((m) => {
      setBgList(m.blood || []);
      setSList((m.state || []).map((x) => ({ value: x.id, label: x.name })));
      setQList((m.qualification || []).map((x) => ({ value: x.id, label: x.qual_name })));
      setDpList((m.department || []).map((x) => ({ value: x.id, label: x.dept_name })));
      setDsList((m.designation || []).map((x) => ({ value: x.id, label: x.desi_name })));
      setRList((m.reporting || []).map((x) => ({ value: x.id, label: x.report_name })));
      setATList((m.appointment || []).map((x) => ({ value: x.id, label: x.appoint_name })));
      setSTList((m.shift || []).map((x) => ({ value: x.id, label: x.shift_name })));
      setClsList((m.class || []).map((x) => ({ value: x.id, label: x.class_name })));
      setSecList(m.division || []);
      setAList((m.academy || []).map((x) => ({ value: x.id, label: x.name + " - " + x.code })));

    if (path === "teacherdetail") {
      teacherview(id).then((res) => {
        if (res.status === true) {
          setTName(res.data.details.teacher_name);
          setDob(res.data.details.date_of_birth);
          setGender(res.data.details.gender);
          setBgroup(res.data.details.bloodgroup);
          if (res.data.details.email_id !== null) {
            setEmail(res.data.details.email_id);
          }
          if (res.data.details.phone !== null) {
            setPhone(res.data.details.phone);
          }
          if (res.data.details.father_name !== null) {
            setFName(res.data.details.father_name);
          }
          if (res.data.details.mother_name !== null) {
            setMName(res.data.details.mother_name);
          }
          if (res.data.details.address1 !== null) {
            setAdd1(res.data.details.address1);
          }
          if (res.data.details.address2 !== null) {
            setAdd2(res.data.details.address2);
          }
          if (res.data.details.district !== null) {
            setDist(res.data.details.district);
          }
          if (res.data.details.city !== null) {
            setCity(res.data.details.city);
          }
          if (res.data.details.pincode !== null) {
            setPincode(res.data.details.pincode);
          }

          if (res.data.details.marital_status !== null) {
            setMstatus(res.data.details.marital_status);
          }
          if (res.data.details.ins_name !== null) {
            setInsName(res.data.details.ins_name);
          }
          if (res.data.details.bank_name !== null) {
            setBName(res.data.details.bank_name);
          }
          if (res.data.details.bank_accno !== null) {
            setAccno(res.data.details.bank_accno);
          }
          if (res.data.details.bank_ifsc !== null) {
            setIfsCode(res.data.details.bank_ifsc);
          }
          if (res.data.details.bank_branch !== null) {
            setBBranch(res.data.details.bank_branch);
          }

          if (res.data.details.adm_date !== null) {
            setADate(res.data.details.adm_date);
          }

          if (res.data.details.teacher_code !== null) {
            setTCode(res.data.details.teacher_code);
          }

          if (res.data.details.teacher_resident !== null) {
            setStuType(res.data.details.teacher_resident);
          }

          if (res.data.details.section_id !== null) {
            setStuSec(res.data.details.section_id);
          }

          if (res.data.details.photo !== null) {
            setPUrl(res.data.path + res.data.details.photo);
            setPFile(res.data.path + res.data.details.photo);
          }

          if (res.data.details.username !== null) {
            setUserName(res.data.details.username);
          }

          if (res.data.password !== null) {
            setPswd(res.data.password);
          }

          // Selected values resolved from the cached master lists (m) — NO extra
          // network calls (removes the duplicate burst that caused [2002]).
          const d = res.data.details;
          const findOpt = (list, id, labelKey) => {
            const hit = (list || []).find((x) => x.id == id);
            return hit ? { value: hit.id, label: hit[labelKey] } : "";
          };
          if (d.state_id)     setState(findOpt(m.state, d.state_id, "name"));
          if (d.qual_id)      setQual(findOpt(m.qualification, d.qual_id, "qual_name"));
          if (d.depart_id)    setDept(findOpt(m.department, d.depart_id, "dept_name"));
          if (d.desig_id)     setDesig(findOpt(m.designation, d.desig_id, "desi_name"));
          if (d.reporting_id) setReport(findOpt(m.reporting, d.reporting_id, "report_name"));
          if (d.appoint_id)   setAppoint(findOpt(m.appointment, d.appoint_id, "appoint_name"));
          if (d.shift_id)     setShift(findOpt(m.shift, d.shift_id, "shift_name"));
          if (d.inc_class)    setIncCls(findOpt(m.class, d.inc_class, "class_name"));
          if (d.subject_id)   setSubj(findOpt(m.subject, d.subject_id, "subject_name"));
          if (d.academy_id) {
            const aca = (m.academy || []).find((x) => x.id == d.academy_id);
            if (aca) setAcaID({ value: aca.id, label: aca.name + " - " + aca.code });
          }
        }
      });
    } else {
      if (localStorage.getItem("ADate") != null) {
        setADate(localStorage.getItem("ADate"));
      } else {
        setADate(moment(new Date()).format("YYYY-MM-DD"));
      }
      if (localStorage.getItem("AAcademy") != null) {
        academylist().then((res) => {
          if (res.status === true) {
            let arr = [];
            if (res.data.details.length > 0) {
              for (let i = 0; i < res.data.details.length; i++) {
                if (res.data.details[i].id == localStorage.getItem("AAcademy")) {
                  arr.push({
                    value: res.data.details[i].id,
                    label:
                      res.data.details[i].name + " - " + res.data.details[i].code,
                  });
                }
                setAcaID(arr[0]);
                listyear(arr[0]);
              }
            }
          }
        });
      }
    }
    });
  }, [location.pathname]);

  const [photoerror, setPhotoError] = useState("");
  function photofile(event) {
    setPhotoError("");
    setPFile("");
    setPUrl("");
    if (event.target.files.length !== 0) {
      if (event.target.files[0].name.match(/\.(jpg|jpeg|png)$/i)) {
        setPUrl(URL.createObjectURL(event.target.files[0]));
        setPFile(event.target.files[0]);
      } else {
        setPhotoError("Photo should be jpg, jpeg, or png format");
      }
      var size = event.target.files[0].size / 1024 / 1024;
      if (size > 5) {
        setPhotoError("Photo size should be less than 5MB");
      }
    }
  }

  function errorphoto(ev) {
    ev.target.src = require("../../../assets/images/teacher.jpg");
    ev.target.onerror = null;
  }
  const handleChange = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPhone(e.target.value);
    }
  };

  const handleAcc = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setAccno(e.target.value);
    }
  };

  const [valmob, setValMob] = useState("");

  function checkphone(e) {
    e.preventDefault();
    setValMob("");
    if (urllink === "addteacher") {
      const temp = new FormData();
      temp.append("phone", e.target.value);
      temp.append("role", 3);
      phonevalidate(temp).then((response) => {
        if (response.status === false) {
          setValMob(response.message);
        }
      });
    }
  }

  const [valpemail, setValPEmail] = useState("");
  function checkpemail(e) {
    e.preventDefault();
    setValPEmail("");
    if (e.target.value !== "") {
      let regEmail = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
      if (!regEmail.test(e.target.value)) {
        setValPEmail("Please Enter a valid Email Address");
      }
    }
  }

  function handleState(e) {
    if (e !== null) {
      setState(e);
    } else {
      setState("");
    }
  }

  const handlePincode = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setPincode(e.target.value);
    }
  };

  function handleQual(e) {
    if (e !== null) {
      setQual(e);
    } else {
      setQual("");
    }
  }

  function handleDept(e) {
    if (e !== null) {
      setDept(e);
    } else {
      setDept("");
    }
  }

  function handleDesi(e) {
    if (e !== null) {
      setDesig(e);
    } else {
      setDesig("");
    }
  }

  function handleSub(e) {
    if (e !== null) {
      setSubj(e);
    } else {
      setSubj("");
    }
  }

  function handleReport(e) {
    if (e !== null) {
      setReport(e);
    } else {
      setReport("");
    }
  }

  function handleAppoint(e) {
    if (e !== null) {
      setAppoint(e);
    } else {
      setAppoint("");
    }
  }

  function handleShift(e) {
    if (e !== null) {
      setShift(e);
    } else {
      setShift("");
    }
  }

  function handleClass(e) {
    if (e !== null) {
      setIncCls(e);
    } else {
      setIncCls("");
    }
  }

  const [errmsg, setError] = useState("");
  const [successmsg, setSuccess] = useState(false);
  function submitstu(e) {
    e.preventDefault();
    setSuccess(true);
    var valid = "";
    if (phone !== "") {
      if (phone.length < 10) {
        valid = "Phone Number should be 10 digits";
        setError("Phone Number should be 10 digits");
      }
    }

    if (pincode !== "") {
      if (pincode.length < 6) {
        valid = "Pincode should be 6 digits";
        setError("Pincode should be 6 digits");
      }
    }

    if (localStorage.getItem("Role") === "1") {
      if (acaid === "") {
        setError("Please Select Academy");
        valid = "Please Select Academy";
      }
    } else {
      valid = "";
    }

    if (
      valid === "" &&
      tname !== "" &&
      gender !== "" &&
      dob !== "" &&
      email !== "" &&
      bgroup !== "" &&
      phone !== "" &&
      add1 !== "" &&
      state !== "" &&
      dist !== "" &&
      city !== "" &&
      pincode !== "" &&
      fname !== "" &&
      mstatus !== "" &&
      qual !== "" &&
      dept !== "" &&
      desig !== "" &&
      bname !== "" &&
      accno !== "" &&
      ifscode !== "" &&
      bbranch !== "" &&
      adate !== "" &&
      valmob === "" &&
      valpemail === ""
    ) {
      setLoading(true);

      const temp = new FormData();
      temp.append("name", tname);
      temp.append("gender", gender);
      temp.append("dob", dob);
      temp.append("blood", bgroup);
      temp.append("email", email);
      temp.append("mobile", phone);
      temp.append("add1", add1);
      temp.append("add2", add2);
      temp.append("state", state.value);
      temp.append("district", dist);
      temp.append("city", city);
      temp.append("pincode", pincode);
      temp.append("father", fname);
      temp.append("mother", mname);
      temp.append("marital", mstatus);

      if (qual !== "") {
        temp.append("qualification", qual.value);
      } else {
        temp.append("qualification", "");
      }

      if (dept !== "") {
        temp.append("department", dept.value);
      } else {
        temp.append("department", "");
      }

      if (desig !== "") {
        temp.append("designation", desig.value);
      } else {
        temp.append("designation", "");
      }
      if (report !== "") {
        temp.append("reporting", report.value);
      } else {
        temp.append("reporting", "");
      }
      if (appoint !== "") {
        temp.append("appointment", appoint.value);
      } else {
        temp.append("appointment", "");
      }
      if (shift !== "") {
        temp.append("shift", shift.value);
      } else {
        temp.append("shift", "");
      }

      temp.append("ins_name", insname);
      temp.append("bank", bname);
      temp.append("accno", accno);
      temp.append("ifsc", ifscode);
      temp.append("branch", bbranch);
      temp.append("adm_date", adate);
      if (inccls !== "") {
        temp.append("incharge", inccls.value);
      } else {
        temp.append("incharge", "");
      }
      if (subj !== "") {
        temp.append("subject", subj.value);
      } else {
        temp.append("subject", "");
      }
      temp.append("section", stusec);
      temp.append("t_code", tcode);
      temp.append("photo", pfile);
      temp.append("user_id", localStorage.getItem("UID"));
      temp.append("teacher_resident", stutype);
      if (vehid !== "") {
        temp.append("vehicle_id", vehid.value);
      } else {
        temp.append("vehicle_id", "");
      }
      if (localStorage.getItem("Role") === "1" && acaid !== "") {
        temp.append("academy", acaid.value);
      }
      if (urllink === "addteacher") {
        teachercreate(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            toast.success(res.message);
            navigate("/teacher/allteacher");
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        });
      } else {
        temp.append("id", id);
        teacherupdate(temp).then((res) => {
          if (res.status === true) {
            setLoading(false);
            toast.success(res.message);
            navigate("/teacher/allteacher");
          } else {
            setLoading(false);
            toast.error(res.message);
          }
        });
      }
    }
  }
  const [loading, setLoading] = useState(false);

  function handleAcademy(e) {
    if (e !== null) {
      setAcaID(e);
      listyear(e);
    } else {
      setAcaID("");
      listyear("");
    }
  }
  function listyear(aid) {
    setVList([]);
    setVehID("");

    const temp = new FormData();
    if (localStorage.getItem("Role") === "1" && aid !== "") {
      temp.append("academy_id", aid.value);
    }
    temp.append("status", 1);
    listvehicle(temp).then((response) => {
      if (response.status === true) {
        let arr = [];
        if (response.data.details.length > 0) {
          for (let i = 0; i < response.data.details.length; i++) {
            arr.push({
              value: response.data.details[i].id,
              label: response.data.details[i].vehicle_no + " - " + response.data.details[i].vehroute_name,
            });
          }
          setVList(arr);
        }
      }
    });
    stusubjectlist(temp).then((res) => {
      if (res.status === true) {
        let arr = [];
        if (res.data.length > 0) {
          for (let i = 0; i < res.data.length; i++) {
            arr.push({
              value: res.data[i].id,
              label: res.data[i].subject_name,
            });
          }
          setSubList(arr);
        }
      }
    });
  }
  function handleVehicle(e) {
    if (e !== null) {
      setVehID(e);
    } else {
      setVehID("");
    }
  }
  const [vlist, setVList] = useState([]);
  const [vehid, setVehID] = useState("");
  return (
    <div>
      <div className="page-header">
        {urllink === "addteacher" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Add Teacher</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Teacher</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Add Teacher
              </li>
            </ol>
          </>
        )}

        {urllink !== "addteacher" && (
          <>
            <h2 className="main-content-title tx-24 mg-b-5">Teacher Details</h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Teacher</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Teacher Details
              </li>
            </ol>
          </>
        )}
      </div>

      {loading && (
        <div className="loader-wrapper">
          <div className="loader"></div>
          <h3>Loading...Please do not go back or close the window.</h3>
        </div>
      )}
      {!loading && (
        <div className="content-body">
          <div className="container-fluid">
            <div className="row">
              <div className="col-xl-12">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Add Teacher Detail
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-3 col-lg-4">
                        <label className="form-label ">Photo</label>
                        <div className="avatar-upload">
                          <div className="avatar-preview">
                            <img
                              src={purl}
                              onError={(e) => errorphoto(e)}
                              alt="Teacher"
                            />
                          </div>
                          <div className="change-btn mt-2 mb-lg-0 mb-3">
                            <input
                              type="file"
                              className="form-control"
                              accept=".png, .jpg, .jpeg"
                              onChange={(e) => photofile(e)}
                            />
                            {photoerror !== "" && (
                              <span className="text-danger">{photoerror}</span>
                            )}
                            <a
                              className="btn btn-secondary my-2"
                              onClick={() => {
                                setPUrl("");
                                setPFile("");
                              }}
                            >
                              Remove
                            </a>
                          </div>
                        </div>


                      </div>
                      <div className="col-xl-9 col-lg-8">
                        <div className="row">
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Teacher Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Teacher Name"
                                value={tname}
                                onChange={(e) => setTName(e.target.value)}
                                onKeyPress={LetterOnly}
                                onPaste={onPasteLetter}
                              />
                              {successmsg && tname === "" && (
                                <span className="text-danger">
                                  Please Enter Teacher Name
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Date Of Birth
                                <span className="text-danger"> *</span>
                              </label>
                              <div className="input-group">
                                <input
                                  className="form-control"
                                  type="date"
                                  value={dob}
                                  onChange={(e) => setDob(e.target.value)}
                                  onKeyPress={(event) => {
                                    event.preventDefault();
                                  }}
                                  onKeyDown={(event) => {
                                    event.preventDefault();
                                  }}
                                />

                              </div>
                              {successmsg && dob === "" && (
                                <span className="text-danger">
                                  Please Enter Date Of Birth
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Blood Group
                                <span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select form-control wide"
                                value={bgroup}
                                onChange={(e) => setBgroup(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Blood Group
                                </option>
                                {bglist.map((item, i) => {
                                  return (
                                    <option value={item.id} key={i}>
                                      {item.name}
                                    </option>
                                  );
                                })}
                              </select>
                              {successmsg && bgroup === "" && (
                                <span className="text-danger">
                                  Please Select Blood Group
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Gender<span className="text-danger"> *</span>
                              </label>
                              <select
                                className="default-select form-control wide"
                                value={gender}
                                onChange={(e) => setGender(e.target.value)}
                              >
                                <option value="" disabled>
                                  Select Gender
                                </option>
                                <option value={"Male"}>Male</option>
                                <option value={"Female"}>Female</option>
                                <option value={"Others"}>Others</option>
                              </select>
                              {successmsg && gender === "" && (
                                <span className="text-danger">
                                  Please Select Gender
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Email<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="email"
                                className="form-control"
                                placeholder="Enter EMail"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                onBlur={checkpemail}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                                onCopy={(e) => {
                                  e.preventDefault();
                                  return false;
                                }}
                              />
                              {successmsg && email === "" && (
                                <span className="text-danger">
                                  Please Enter Email
                                </span>
                              )}
                              {valpemail !== "" && email && (
                                <span className="text-danger">{valpemail}</span>
                              )}
                            </div>
                          </div>
                          {urllink === "addteacher" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Phone Number
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Phone Number"
                                  onChange={handleChange}
                                  onBlur={checkphone}
                                  value={phone}
                                  maxLength={10}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                />
                                {valmob !== "" && phone && (
                                  <span className="text-danger">{valmob}</span>
                                )}
                                {successmsg && phone === "" && (
                                  <span className="text-danger">
                                    Please Enter Phone Number
                                  </span>
                                )}
                              </div>
                            </div>
                          )}

                          {urllink !== "addteacher" && (
                            <div className="col-xl-6 col-sm-6">
                              <div className="mb-3">
                                <label className="form-label">
                                  Phone Number
                                  <span className="text-danger"> *</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Enter Phone Number"
                                  onChange={handleChange}
                                  value={phone}
                                  maxLength={10}
                                  onPaste={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  onCopy={(e) => {
                                    e.preventDefault();
                                    return false;
                                  }}
                                  disabled
                                />
                                {successmsg && phone === "" && (
                                  <span className="text-danger">
                                    Please Enter Phone Number
                                  </span>
                                )}
                              </div>
                            </div>
                          )}

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Father Name
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Father Name"
                                onKeyPress={LetterOnly}
                                onPaste={onPasteLetter}
                                value={fname}
                                onChange={(e) => setFName(e.target.value)}
                              />
                              {successmsg && fname === "" && (
                                <span className="text-danger">
                                  Please Enter Father Name
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Mother Name
                                {/* <span className="text-danger"> *</span> */}
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Mother Name"
                                onKeyPress={LetterOnly}
                                onPaste={onPasteLetter}
                                value={mname}
                                onChange={(e) => setMName(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Address 1<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address 1"
                                value={add1}
                                onChange={(e) => setAdd1(e.target.value)}
                              />
                              {successmsg && add1 === "" && (
                                <span className="text-danger">
                                  Please Enter Address 1
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">Address 2</label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Address 2"
                                value={add2}
                                onChange={(e) => setAdd2(e.target.value)}
                              />
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                State<span className="text-danger"> *</span>
                              </label>
                              <Select
                                className="default-select"
                                placeholder="Select State"
                                value={state}
                                options={slist}
                                onChange={handleState}
                                isSearchable={true}
                                isClearable
                                hidden
                              />

                              {successmsg && state === "" && (
                                <span className="text-danger">
                                  Please Select State
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                District<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter District"
                                value={dist}
                                onChange={(e) => setDist(e.target.value)}
                              />
                              {successmsg && dist === "" && (
                                <span className="text-danger">
                                  Please Enter District
                                </span>
                              )}
                            </div>
                          </div>
                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                City<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Your City / Thaluk"
                                value={city}
                                onChange={(e) => setCity(e.target.value)}
                              />
                              {successmsg && city === "" && (
                                <span className="text-danger">
                                  Please Enter City
                                </span>
                              )}
                            </div>
                          </div>

                          <div className="col-xl-6 col-sm-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Pincode<span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                className="form-control"
                                placeholder="Enter Pincode"
                                maxLength={6}
                                value={pincode}
                                onChange={handlePincode}
                              />
                              {successmsg && pincode === "" && (
                                <span className="text-danger">
                                  Please Enter Pincode
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-2">
              <div className="col-xl-8">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Teacher Other Details
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      {localStorage.getItem("Role") === "1" && (
                        <div className="col-xl-6 col-sm-6">
                          <div className="mb-3">
                            <label className="form-label ">
                              Select Academy
                              <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Academy"
                              value={acaid}
                              options={alist}
                              onChange={handleAcademy}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                            {successmsg && acaid === "" && (
                              <span className="text-danger">
                                Please Select Academy
                              </span>
                            )}
                          </div>
                        </div>
                      )}
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Marital Status
                            <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select form-control wide"
                            value={mstatus}
                            onChange={(e) => setMstatus(e.target.value)}
                          >
                            <option value="" disabled>
                              Select Marital Status
                            </option>
                            <option value="Single">Single</option>
                            <option value="Married">Married</option>
                          </select>
                          {successmsg && mstatus === "" && (
                            <span className="text-danger">
                              Please Select Marital Status
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Qualification
                            <span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Qualification"
                            value={qual}
                            options={qlist}
                            onChange={handleQual}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                          {successmsg && qual === "" && (
                            <span className="text-danger">
                              Please Select Qualification
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Department<span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Department"
                            value={dept}
                            options={dplist}
                            onChange={handleDept}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                          {successmsg && dept === "" && (
                            <span className="text-danger">
                              Please Select Department
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Designation<span className="text-danger"> *</span>
                          </label>
                          <Select
                            className="default-select"
                            placeholder="Select Designation"
                            value={desig}
                            options={dslist}
                            onChange={handleDesi}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                          {successmsg && desig === "" && (
                            <span className="text-danger">
                              Please Select Designation
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Subject</label>
                          <Select
                            className="default-select"
                            placeholder="Select Subject"
                            value={subj}
                            options={sublist}
                            onChange={handleSub}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Reporting To</label>
                          <Select
                            className="default-select"
                            placeholder="Select Reporting To"
                            value={report}
                            options={rlist}
                            onChange={handleReport}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Appointment Type</label>
                          <Select
                            className="default-select"
                            placeholder="Select Appointment Type"
                            value={appoint}
                            options={atlist}
                            onChange={handleAppoint}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">Shift</label>
                          <Select
                            className="default-select"
                            placeholder="Select Shift"
                            value={shift}
                            options={stlist}
                            onChange={handleShift}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Previous Institute Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Previous Institute Name"
                            value={insname}
                            onChange={(e) => setInsName(e.target.value)}
                            onKeyPress={LetterOnly}
                            onPaste={onPasteLetter}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Bank Name<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Bank Name"
                            value={bname}
                            onChange={(e) => setBName(e.target.value)}
                            onKeyPress={LetterOnly}
                            onPaste={onPasteLetter}
                          />
                          {successmsg && bname === "" && (
                            <span className="text-danger">
                              Please Enter Bank Name
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Bank Account No
                            <span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Bank Account No"
                            value={accno}
                            onChange={handleAcc}
                          />
                          {successmsg && accno === "" && (
                            <span className="text-danger">
                              Please Enter Bank Account No
                            </span>
                          )}
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label ">
                            Bank IFSC Code<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Bank IFSC Code"
                            value={ifscode}
                            onChange={(e) => setIfsCode(e.target.value)}
                          />
                        </div>
                      </div>
                      <div className="col-xl-6 col-sm-6">
                        <div className="mb-3">
                          <label className="form-label">
                            Bank Branch<span className="text-danger"> *</span>
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter Bank Branch"
                            value={bbranch}
                            onChange={(e) => setBBranch(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-xl-4">
                <div className="card">
                  <div className="card-header">
                    <h2 className="main-content-title tx-24 mg-b-5">
                      Teacher Admission Details
                    </h2>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-xl-12 col-sm-12">


                        <div className="mb-3">
                          <label className="form-label ">
                            Admission Date
                            <span className="text-danger"> *</span>
                          </label>
                          <div className="input-group">
                            <input
                              className="form-control"
                              type="date"
                              value={adate}
                              onChange={(e) => setADate(e.target.value)}
                              onKeyPress={(event) => {
                                event.preventDefault();
                              }}
                              onKeyDown={(event) => {
                                event.preventDefault();
                              }}
                            />
                            {successmsg && adate === "" && (
                              <span className="text-danger">
                                Please Select Admission Date
                              </span>
                            )}
                          </div>
                        </div>

                        <div className="mb-3">
                          <label className="form-label ">Incharge Class </label>
                          <Select
                            className="default-select"
                            placeholder="Select Incharge Class"
                            value={inccls}
                            options={clslist}
                            onChange={handleClass}
                            isSearchable={true}
                            isClearable
                            hidden
                          />
                        </div>
                        <div className="mb-3">
                          <label className="form-label ">
                            Section
                            {/* <span className="text-danger"> *</span> */}
                          </label>
                          <select
                            value={stusec}
                            onChange={(e) => setStuSec(e.target.value)}
                            className="default-select  form-control wide"
                          >
                            <option value="" disabled>
                              Select Section
                            </option>
                            {seclist.map((item) => {
                              return (
                                <option value={item.id} key={item.id}>
                                  {item.name}
                                </option>
                              );
                            })}
                          </select>
                        </div>

                        <div className="mb-3">
                          <label className="form-label">
                            Resident Type <span className="text-danger"> *</span>
                          </label>
                          <select
                            className="default-select  form-control wide"
                            value={stutype}
                            onChange={(e) => setStuType(e.target.value)}
                          >
                            <option value="" disabled>
                              Select Type
                            </option>
                            <option value={1}>Day Scholar</option>
                            <option value={2}>Hosteller</option>
                            <option value={3}>Bus</option>

                          </select>
                          {successmsg && stutype === "" && (
                            <span className="text-danger">
                              Please Select Type
                            </span>
                          )}
                        </div>
                        {stutype == 3 &&
                          <div className="mb-3">
                            <label className="form-label">
                              Vehicle <span className="text-danger"> *</span>
                            </label>
                            <Select
                              className="default-select"
                              placeholder="Select Vehicle"
                              value={vehid}
                              options={vlist}
                              onChange={handleVehicle}
                              isSearchable={true}
                              isClearable
                              hidden
                            />
                            {successmsg && vehid === "" && stutype == 3 && (
                              <span className="text-danger">
                                Please Select Vehicle
                              </span>
                            )}
                          </div>

                        }
                        <div className="mb-3">
                          <label className="form-label ">
                            Teacher Code
                            {/* <span className="text-danger"> *</span> */}
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Teacher Code"
                            value={tcode}
                            onChange={(e) => setTCode(e.target.value)}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="res-right mt-2 me-4">
              {urllink === "addteacher" && (
                <button className="btn btn-success" onClick={submitstu}>
                  Submit
                </button>
              )}

              {urllink !== "addteacher" && (
                <>
                  <button className="btn btn-success me-2" onClick={submitstu}>
                    Update
                  </button>
                  <button
                    className="btn btn-secondary"
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
